import React from "react";
import { Link } from "react-router-dom";

// CSS
import "../../../css/linked-title.css";

class LinkedTitle extends React.PureComponent {
	render() {
		return (
			<div className="linked-title">
				<h1>{this.props.children}</h1>
				<Link className="btn" to={this.props.link.href}>
					{this.props.link.title}
				</Link>
			</div>
		);
	}
}

export default LinkedTitle;



// WEBPACK FOOTER //
// ./src/components/utils/titles/LinkedTitle.js